export default "/images/f310f51edac0f184ac20f37617eed150.avif";